<template>
        <div class="card">
            <row class="mt-3">
              <h4 class="ml-5 "> Orders Attendance </h4> 
            </row>
            <br>
            <row >
              <p class="ml-5"> Name: {{ data.name }}</p>
              <p class="ml-5"> Address: {{ data.address }} </p>
              <p class="ml-5"> Email: {{ data.email }} </p>
              <p class="ml-5"> Mobile Phone: {{ data.mobile_phone }} </p>
              <p class="ml-5"> Payment Status: {{ data.payment_status }} </p>
            </row>
            <br>
            <row class="mt-3 ml-3" v-if="mode === 'create'">
              <row>
                <label class="ml-5 mt-3 text-info" > Ticket Details </label>
              </row>
              <row class="mt-3 ml-3">
                <table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Quantity</th>
                        <th>Attend</th>
                    </tr>
                    </thead>
                    <tr v-for="(arr, index) in form.att" :key="index">
                        <td>
                          {{ arr.type.name }}
                        </td>
                        <td>
                            {{ arr.qty }} Ticket
                        </td>
                        <td>
                            <CInput
                              type="number"
                              label=""
                              v-model="arr.attend"
                              min="0"                 
                              :invalid-feedback="messageInvalidFeedback(arr.qty)"  
                              :is-valid="validatorTicket(arr.attend,arr.qty)" 
                            />
                        </td>
                    </tr>
                </table>
              </row>
            </row>
            <br>
            <row class="mt-3 ml-3" v-if="mode === 'edit'">
              <row>
                <label class="ml-5 mt-3 text-info" > Ticket Details</label>
              </row>
              <row class="mt-3 ml-3">
                <table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Quantity</th>
                    </tr>
                    </thead>
                    <tr v-for="(arr, index) in form.att" :key="index">
                        <td>
                          {{ arr.type.name }}
                        </td>
                        <td>
                            {{ arr.qty }} Ticket
                        </td>
                    </tr>
                </table>
              </row>
              <row class="mt-3 ml-3">
                <table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Attend</th>
                    </tr>
                    </thead>
                    <tr v-for="(arr, index) in form.att_edit" :key="index">
                        <td>
                          {{ arr.type.name }}
                        </td>
                        <td>
                            <CInput
                              type="number"
                              label=""
                              v-model="arr.qty"
                              min="0"                 
                              :invalid-feedback="messageInvalidFeedback(arr.type.max)"  
                              :is-valid="validatorTicket(arr.qty,arr.type.max)" 
                            />
                        </td>
                    </tr>
                </table>
              </row>
            </row>
            <row class="mt-3 ml-3">
              <CButton v-if="mode === 'create'" style="width:200px" color="success" block v-on:click.prevent="submit()" type="submit" >Submit</CButton>
              <CButton v-if="mode === 'edit'" style="width:200px" color="success" block v-on:click.prevent="update()" type="submit" >Update</CButton>
            </row>


<!-- <pre>{{ $data | json }}</pre> -->
</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import event from '@/services/event';

export default {
  

    data(){
        return{
          data:[],
          form:{
              event_id:'',
              name:'',
              adrress:'',
              email:'',
              phone:'',
              mobile_phone:'',
              total:'',
              form_field:[],
              custom_tickets:[],
              admission_fee:'',
              att:[],
              att_edit:[],
          },
          eventID:'',
          eventName:'',
          message:'',
          qrcode:'',
          mode:''
        }
    },
    mounted() {
      this.loadData()
    },
    computed: {
        subtotalRow() {
          return this.form.custom_tickets.map((arr) => {
            return arr.total = Number(arr.qty * arr.price) || 0
          });
        },

        total() {
          return this.form.custom_tickets.reduce((total, item) => {
            return this.form.total = total + item.total;
          }, 0);
        }

    },
    methods: {
      loadData(){
        this.mode = this.$route.query.mode;

        event.getEventbyID_getorderdetail(this.$route.query.id)
        .then(res => {
          this.data = res.data
          this.message = res.message
          this.eventName = res.data.name
          this.eventID = res.data.id
          this.form.event_id = res.data.id
          this.form.form_field = JSON.parse(res.data.form_field);
          this.form.custom_tickets = res.data.event_tickets;
          this.form.admission_fee = res.data.admission_fee;
          this.qrcode = "http://localhost:8005/api/getqrcode/" + res.data.code;
          this.form.att = res.data.order_details
          this.form.att_edit = res.data.order_attendances
        }) 
                
      },   
      getQR(value){
        return 'http://localhost:8005/api/getqrcode/' + value;
      },

      validatorTicket: function(val,max) {
        if(val >= 0 && val <= max){
          return null;
        }else{
          return false;
        }
        //return val ? (val >= 0 && val <= max) : false
      },
      messageInvalidFeedback: function(max) {
        return "Maksimal " + max + " tiket"
      },
      submit(){
        //alert('asd');
        //this.loading_submit = true
        event.createEventAttendance(this.$route.query.id, this.form)
        .then(res => {
            alert(res.message)
        }).catch ((err) => {
            console.log(err.response.data.message)
            alert(err.response.data.message)
        })
      },
      update(){
        //alert('asd');
        //this.loading_submit = true
        event.updateEventAttendance(this.$route.query.id, this.form)
        .then(res => {
            alert(res.message)
        }).catch ((err) => {
            console.log(err.response.data.message)
            alert(err.response.data.message)
        })
      }

    }
}
</script>
